/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_TitleInputs */



/**
* | output |
* | --- |
* | "Share Project" |
*
* @param {Team_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_title = /** @type {((inputs?: Team_Share_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partager le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt teilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Совместный проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compartir proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを共有")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट साझा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compartilhar Projeto")
	return /** @type {LocalizedString} */ ("Share Project")
});